import { render, staticRenderFns } from "./CasinoWinnerView.vue?vue&type=template&id=16884acc&scoped=true"
import script from "./CasinoWinnerView.vue?vue&type=script&lang=js"
export * from "./CasinoWinnerView.vue?vue&type=script&lang=js"
import style0 from "./CasinoWinnerView.vue?vue&type=style&index=0&id=16884acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16884acc",
  null
  
)

export default component.exports